import React, { useEffect, useState } from "react";
import { faPlus } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TabView, TabPanel } from "primereact/tabview";
import Account from "../components/profile/Account";
import Newsletter from "../components/Newsletter";
import Favorite from "../components/profile/Favorite";
import AdditionalInfo from "../components/profile/AdditionalInfo";
import "./Profile.scss";

export default function Profile({ account, setAccount, api, messenger }) {
  
  const [tabIndex, setTabIndex] = useState(0)
  const nameUser = account ? account.first_name + " " + account.last_name : "";

  useEffect(() => {
    const tab = new URLSearchParams(window.location.search).get("tab") || "default"
    const tabs = {
      default: 0,
      favorite: 1,
      "additional-info": 2
    }
    setTabIndex(tabs[tab])
  }, [setTabIndex])

  const getAcronyms = () => {
    let names = nameUser.split(" ");
    let initials = names[0].substring(0, 1).toUpperCase();

    if (names.length > 1) {
      initials += names[names.length - 1].substring(0, 1).toUpperCase();
    }
    return initials;
  };

  const validationImage = (file) => {
    const size = file.size / 1024 / 1024;
    if (
      size >= 5 ||
      (file.type !== "image/jpeg" &&
        file.type !== "image/jpg" &&
        file.type !== "image/png")
    ) {
      messenger({
        severity: "warn",
        detail: "Picture invalid, please try again.",
        life: 3000,
      });
      return false;
    }
    return true;
  };

  const updateAvatar = (e) => {
    const file = e.target.files[0];

    if (validationImage(file)) {
      let data = new FormData();
      data.append("profile_image_url", file);

      api(`api/providers/${process.env.REACT_APP_SLUG}/users/my_profile/`, {
        method: "PATCH",
        ignoreError: true,
        body: data,
      }).then(({ ok }) => {
        if (ok) {
          messenger({
            severity: "success",
            detail: "Picture successfully changed.",
            life: 3000,
          });
          api(`api/providers/${process.env.REACT_APP_SLUG}/users/me/`).then(
            ({ body }) => {
              setAccount(body?.data);
            },
          );
        } else {
          messenger({
            severity: "error",
            detail: "Unable to update, please try again..",
            life: 3000,
          });
        }
      });
    }
  };

  return (
    <div className="profile-page">
      <div className="header">
        <div className="bw-event-container">
          <div className="info-user">
            <div className="avatar">
              {account.profile_image_url ? (
                <picture>
                  <img src={account.profile_image_url} alt={getAcronyms()} />
                </picture>
              ) : (
                getAcronyms()
              )}
              <div className="upload">
                <label htmlFor="upload">
                  <FontAwesomeIcon icon={faPlus} style={{ color: "#1976D2" }} />
                </label>
                <input
                  id="upload"
                  type="file"
                  accept="image/png, image/jpg, image/jpeg"
                  className="bw-event-btn"
                  onChange={updateAvatar}
                />
              </div>
            </div>
            <div className="info">
              <h2>Welcome, {nameUser}!</h2>
              <p>Manage your personal info, interests and security</p>
            </div>
          </div>
        </div>
      </div>
      <div className="bw-event-container content mb-5">
        <TabView className="tabs" activeIndex={tabIndex} onTabChange={(e) => setTabIndex(e.index)}>
          {account ? (
            <TabPanel className="tab" header="Account info">
              <Account
                setAccount={setAccount}
                api={api}
                messenger={messenger}
                account={account}
              />
            </TabPanel>
          ) : (
            ""
          )}
          <TabPanel className="tab" header="Favorites">
            <Favorite api={api} account={account} setAccount={setAccount} />
          </TabPanel>
          <TabPanel className="tab" header="Additional info">
            <AdditionalInfo api={api} setAccount={setAccount} messenger={messenger} account={account} />
          </TabPanel>
        </TabView>
      </div>
      <Newsletter api={api} messenger={messenger} />
    </div>
  );
}
